import {
  getSessionStorage,
  setSessionStorage
} from '@cat-ecom/common/utils/storageUtils';
import { useEffect, useMemo, useState } from 'react';
import {
  CURRENT_PAGE,
  STORE_LOCATOR_TOOL_TIP
} from '../components/store/constants';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { usePathMatch } from 'hooks/use-path-match';

export const useStoreLocatorTooltip = (
  isGuestUserOnCatcorp: boolean,
  isMobile: boolean
) => {
  const [isTooltipActive, setIsTooltipActive] = useState(false);
  const isMd = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const isLg = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const isTablet = isMd && !isLg && isMobile;
  const isDesktop = isLg && !isMobile;
  const isMediumDevice = isTablet || isDesktop;
  const isCategoryPage = usePathMatch(CURRENT_PAGE[0].path);
  const isSearchPage = usePathMatch(CURRENT_PAGE[1].path);
  let currentPage = null;
  if (isCategoryPage) {
    currentPage = CURRENT_PAGE[0].pageName;
  } else if (isSearchPage) {
    currentPage = CURRENT_PAGE[1].pageName;
  }
  const shouldDisplayTooltip = useMemo(() => {
    return isMd && isTooltipActive;
  }, [isMd, isTooltipActive]);

  useEffect(() => {
    const storeLocatorValue =
      JSON.parse(getSessionStorage(STORE_LOCATOR_TOOL_TIP)) ?? [];
    const shouldSetSessionStorageValue =
      !storeLocatorValue.includes(currentPage);
    if (
      !!currentPage &&
      isGuestUserOnCatcorp &&
      isMediumDevice &&
      shouldSetSessionStorageValue
    ) {
      setIsTooltipActive(true);
      setSessionStorage(
        STORE_LOCATOR_TOOL_TIP,
        JSON.stringify([...storeLocatorValue, currentPage])
      );
    }
  }, [isGuestUserOnCatcorp, currentPage, isTooltipActive, isMediumDevice]);
  const handleToolTip = () => {
    setIsTooltipActive(false);
  };
  return { handleToolTip, shouldDisplayTooltip };
};